import pusherReducer, { PusherState } from '@src//state/pusher/reducer'
import appStateReducer, { AppState } from '@src/state/app/reducer'
import auth, { AuthState } from '@src/state/auth/reducer'
import checks, { CheckState } from '@src/state/checks/reducer'
import documentReducer, { DocumentState } from '@src/state/document/reducer'
import featureFlagsReducer from '@src/state/featureFlags/reducer'
import { FeatureFlagsState } from '@src/state/featureFlags/types'
import modalReducer, { ModalState } from '@src/state/modals/reducer'
import modules, { ModuleState } from '@src/state/modules/reducer'
import papersReducer, { PaperState } from '@src/state/papers/reducer'
import paymentReducer, { PaymentState } from '@src/state/payment/reducer'
import siteReducer from '@src/state/site/reducer'
import workspaceReducer, { WorkspaceState } from '@src/state/workspace/reducer'
import { ActionTypes } from '@src/types/actions'
import { connectRouter, RouterState } from 'connected-react-router'
import { History } from 'history'
import { AnyAction, combineReducers, Reducer } from 'redux'
import experimentReducer, { ExperimentState } from './experiment/reducer'
import expertCheckReducer, { ExpertCheckState } from './expertcheck/reducer'
import { SiteState } from './site/types'

export interface StoreState {
  document: DocumentState
  papers: PaperState
  modals: ModalState
  auth: AuthState
  checks: CheckState
  router: RouterState
  modules: ModuleState
  app: AppState
  payment: PaymentState
  workspace: WorkspaceState
  site: SiteState
  pusher: PusherState
  expertCheck: ExpertCheckState
  experiment: ExperimentState
  featureFlags: FeatureFlagsState
}

export const createRootReducer = (history: History<any>) =>
  combineReducers({
    router: connectRouter(history),
    document: documentReducer,
    modals: modalReducer,
    auth,
    checks,
    papers: papersReducer,
    modules,
    app: appStateReducer,
    payment: paymentReducer,
    workspace: workspaceReducer,
    site: siteReducer,
    pusher: pusherReducer,
    expertCheck: expertCheckReducer,
    experiment: experimentReducer,
    featureFlags: featureFlagsReducer,
  })

/**
 * Root Reducer
 */
const rootReducerFactory = (rootReducers: Reducer<any, AnyAction>) => {
  return (state: StoreState, action: ActionTypes) => {
    return rootReducers(state, action)
  }
}

export default rootReducerFactory



// WEBPACK FOOTER //
// ./src/state/reducers.ts